<div class="trip-detail-popup-right">
  <img
    src="../../../assets/img/icons8-macos-close-60.png"
    class="close-icons"
    (click)="close()"
  />
</div>

<div class="image">
  <img src="../../../assets/img/lorry.svg" />
</div>

<form class="admin-forms" [formGroup]="notifyform">
  <div class="accordion-class">
    <h5>Retail Notify Near by Drivers</h5>
    <mat-divider></mat-divider>
  </div>
  <div class="input-fileds-container">
    <div class="group driver-truck">
      <div class="row mtb align-items-center">
        <div class="col-md-3">
          <label for="html">Trip ID</label>
        </div>
        <div class="col-md-3">
          <mat-form-field
            class="flex-gt-sm example-full-width truck-type-input"
          >
            <input formControlName="trip_id" matInput type="text" readonly />
          </mat-form-field>
        </div>
      </div>

      <div class="row mtb align-items-center">
        <div class="col-md-3">
          <label for="html">Pickup Location</label>
        </div>
        <div class="col-md-3">
          <mat-form-field class="flex-gt-sm example-full-width">
            <input
              style="color: black"
              formControlName="from_city_name"
              #pickUpLocationSearchField
              matInput
              type="text"
              readonly
            />
          </mat-form-field>
        </div>

        <div class="col-md-3">
          <label for="html">Dropup Location</label>
        </div>
        <div class="col-md-3 total_tons">
          <mat-form-field class="flex-gt-sm">
            <input
              style="color: black; float: right"
              formControlName="to_city_name"
              #dropLocationSearchField
              matInput
              type="text"
              readonly
            />
          </mat-form-field>
        </div>
      </div>
      <hr />
      <h5 class="c2">Trip Details</h5>
      <div class="row mtb align-items-center">
        <div class="col-md-3">
          <label for="html"> Trip Booking Date</label>
        </div>
        <div class="col-md-3">
          <mat-form-field>
            <input matInput formControlName="trip_start" readonly />
          </mat-form-field>
        </div>
        <div class="col-md-3">
          <label for="html">Truck Category</label>
        </div>
        <div class="col-md-3">
          <mat-form-field class="flex-gt-sm">
            <input
              matInput
              type="text"
              formControlName="truck_category_name"
              readonly
            />
          </mat-form-field>
        </div>
      </div>
      <div class="row mtb align-items-center">
        <div class="col-md-3">
          <label for="html"> Load Details</label>
        </div>
        <div class="col-md-3">
          <mat-form-field class="flex-gt-sm">
            <input matInput formControlName="load_type" readonly />
            <mat-error>Please enter price per ton in numbers</mat-error>
          </mat-form-field>
        </div>

        <div class="col-md-3">
          <label for="html">Weight</label>
        </div>
        <div class="col-md-3">
          <mat-form-field>
            <input
              type="text"
              matInput
              formControlName="truck_weight"
              readonly
            />
          </mat-form-field>
        </div>
      </div>

      <hr />
      <h5 class="c3">Notification Settings (From Pickup)</h5>
      <br />
      <div class="row mtb align-items-center">
        <div class="col-md-3">
          <mat-radio-button
            [checked]="selectedOption === 'notificationRadius'"
            (change)="onSelectionChange('notificationRadius')"
          >
          </mat-radio-button>
          <label for="html">Notification Radius</label>
        </div>
        <div class="col-md-3">
          <mat-form-field
            class="flex-gt-sm example-full-width truck-type-input"
          >
            <input
              matInput
              appTwoDigitDecimaNumber
              formControlName="notification_radius"
              [readonly]="selectedOption !== 'notificationRadius'"
              (ngModelChange)="onNotificationRadiusChange($event)"
              required
            />
            <mat-error
              >Please click radio button of notification radius</mat-error
            >
          </mat-form-field>
        </div>
        <div class="col-md-3">
          <label for="html">KMS</label>
        </div>
        <div class="col-md-3">
          <mat-radio-button
            formControlName="all_transporters"
            [value]="'allTransporters'"
            (click)="selectLoadedQty('true')"
            (change)="onSelectionChange('allTransporters')"
          >
          </mat-radio-button>
          <label for="html">All Transporters</label>
        </div>
      </div>
      <div class="row mtb align-items-center">
        <div class="col-md-3">
          <mat-radio-button
            [checked]="selectedOption === 'truckHomeLocations'"
            (change)="onSelectionChange('truckHomeLocations')"
          >
          </mat-radio-button>
          <label for="html">Truck Home Locations</label>
        </div>
        <div class="col-md-3">
          <mat-form-field
            class="flex-gt-sm example-full-width truck-type-input"
          >
            <mat-select
              formControlName="truck_home_location"
              (selectionChange)="onTruckHomeLocationChange($event)"
              [disabled]="selectedOption !== 'truckHomeLocations'"
              required
            >
              <mat-option *ngFor="let item of cityData" [value]="item">{{
                item
              }}</mat-option>
            </mat-select>
            <mat-error>Please select truck home locations</mat-error>
          </mat-form-field>
        </div>
        <div class="col-md-3">
          <label for="html">Timer</label>
        </div>
        <div class="col-md-3 d-flex">
          <mat-form-field
            class="flex-gt-sm example-full-width truck-type-input"
          >
            <input
              matInput
              appTwoDigitDecimaNumber
              formControlName="timer"
              required
            />
            <mat-error>Please enter timer</mat-error>
          </mat-form-field>
          <p class="Mins">Mins</p>
        </div>
      </div>
      <div class="row">
        <div class="ex0 buttons">
          <button type="submit" class="button buttonBlue" (click)="notify()">
            Submit
          </button>
        </div>
      </div>
    </div>
  </div>
</form>
